import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map((chat) => chat.meta.sender)
  );
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType,
  { isDeltaFetch = false } = {}
) => {
  const { payload: conversationList, meta: metaData } = responseData;

  if (isDeltaFetch) {
    // Il delta porta solo le conversazioni toccate durante lo stacco: va fuso
    // nella lista esistente, che resta quella della vista corrente.
    context.commit(types.MERGE_CONVERSATION_LIST_DELTA, conversationList);
  } else {
    context.commit(types.SET_ALL_CONVERSATION, conversationList);
  }
  context.commit(
    `conversationStats/${types.UPDATE_CONVERSATION_STATS}`,
    metaData,
    { root: true }
  );
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  // Nel delta non c'è una pagina da registrare: la richiesta parte con
  // page: null e la risposta non è una pagina della lista, quindi non ha senso
  // sovrascrivere la pagina corrente né dichiarare la fine dello scorrimento.
  if (!isDeltaFetch) {
    setPageFilter({
      dispatch: context.dispatch,
      filter: filterType,
      page: requestPayload.page,
      markEndReached: !conversationList.length,
    });
  }
};
